var shopthru_observer;
var shopthru_balloon = null;

$( document ).ready(function() {
	console.log( "shopthru override..." );

	var new_shopthru_container = $("[id^='shopthru_container']");
	var shopthru_block = $("[id^='shopify-block']");

	if (new_shopthru_container.length > 0) {
		new_shopthru_container[0].appendChild(shopthru_block[0]);
	}
	else {
		console.log("Could not find shopthru_container.  Hiding shopthru button");
		shopthru_block[0].style.display = "none";
	}
	
	shopthru_balloon = $("#shopthru-embedded-block");
	shopthru_balloon[0].style.position = "relative";
	shopthru_balloon.removeClass("bottom-right");
	shopthru_balloon.removeClass("top-right");
	shopthru_balloon[0].style.removeProperty('top');
	shopthru_balloon[0].style.removeProperty('bottom');
	shopthru_balloon[0].style.removeProperty('left');
	shopthru_balloon[0].style.removeProperty('right');
	//shopthru_balloon[0].style.zIndex = "auto";
	//$("[class^='AppLauncherstyled__EmbeddedButton']").css("z-index", 'auto');
	
	//the button isn't rendered until after initial page load so we have to use an observer
	shopthru_observer = new MutationObserver(function(mutations_list) {
		mutations_list.forEach(function(mutation) {
			mutation.addedNodes.forEach(function(added_node) {
				/*
				console.log('element has been added: ' + added_node.id);
				console.log('id=' + added_node.id); */
				if (added_node.classList == null) {
					console.log('element has been added.  class=' + added_node.id ? added_node.id : "");
				}
				else {
					console.log('element has been added.  class=' + added_node.classList.toString());
				}
				
				onDomChange(added_node);
			});
		});
	});
	
	shopthru_observer.observe(shopthru_balloon[0], { subtree: true, childList: true });
	
});


function onDomChange(domElement) {
	if (domElement.classList == null) return;

	for (const c of domElement.classList) {
		if (c.startsWith('AppLauncherstyled__EmbeddedButton')) { //outer container
			//console.log('element added. class = ' + c);

			domElement.style.margin = 'auto';
			//domElement.style.zIndex = "auto"; makes the page shift left on mobile
			//domElement.style.removeProperty('z-index'); doesn't remove z-index
			//domElement.style.zIndex = "1"
			//$("[class^='AppLauncherstyled__EmbeddedButton']").css("z-index", 'auto');

			var button = $("[class^='AppLauncherstyled__ContentContainer']");
			if (button.length > 0) {
				replaceChildButtonText(button[0]);
			}

			//domElement.click(); //causes the modal dialog to show up
		}
		else if (c.startsWith('AppLauncherstyled__ContentContainer')) { //inner container
			//console.log('element added. class = ' + c);

			//$("[class^='AppLauncherstyled__EmbeddedButton']").css("z-index", 'auto');

			if (domElement.firstChild.nodeName.toUpperCase() == 'SVG') { //click to get past the first button
				domElement.click();
			} 
			else {
				replaceChildButtonText(domElement);
			}
		}
	}
}

//replace stupid "perks inside" text with some better text
function replaceChildButtonText(element) {
	if (element.firstChild.nodeName.toUpperCase() == 'SPAN') {
		element.firstChild.innerHTML = "Connect Your Wallet";
	}
} 

/*
var yn = false;
function findButton(domElement) {
	for (const c of domElement.classList) {
		if (c.startsWith('AppLauncherstyled__EmbeddedButton')) {
			console.log('element added. class = ' + c);

			domElement.style.margin = 'auto';
			//domElement.click(); //causes the modal dialog to show up
			//observer.disconnect();

			//break;

		}
		else if (c.startsWith('AppLauncherstyled__ContentContainer')) {
			console.log('element added. class = ' + c);

			domElement.innerHTML = "<span>Connect your wallet...</span>";
			//observer.disconnect();

			/*
			if (yn == false) {
				domElement.click();
				yn = true;
			}
			if (yn == false) {
				domElement.click();
				yn = true;
			}

			//break;
		}
	}
}
*/

/*
var a = $("[class^='AppLauncherstyled__EmbeddedButton']")[0];
var b = $("[class^='AppLauncherstyled__ContentContainer']")[0];


*/